import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { selectCompanyName } from '../selectors';

// The redirect every private route sends an unauthenticated parent to.
// Rendered as a component (rather than built inline in each guard) so the
// guards stay free of the /login-redirect location-state contract.
const LoginRedirect = () => {
  const companyName = useSelector(selectCompanyName);

  return (
    <Redirect
      to={{
        pathname: '/login-redirect',
        state: { className: companyName, reloadRequired: true },
      }}
    />
  );
};

export default LoginRedirect;
